import { render } from "./MediaProperties.vue?vue&type=template&id=3e404361&scoped=true"
import script from "./MediaProperties.vue?vue&type=script&lang=js"
export * from "./MediaProperties.vue?vue&type=script&lang=js"

import "./MediaProperties.vue?vue&type=style&index=0&id=3e404361&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e404361"],['__file',"src/components/mediaproperty/MediaProperties.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e404361"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e404361', __exports__)) {
    api.reload('3e404361', __exports__)
  }
  
  module.hot.accept("./MediaProperties.vue?vue&type=template&id=3e404361&scoped=true", () => {
    api.rerender('3e404361', render)
  })

}


export default __exports__